module.exports = __webpack_public_path__ + "static/media/logo-white.30c83d3e.svg";